import { render, staticRenderFns } from "./MoreActions.vue?vue&type=template&id=20919e18&scoped=true&"
import script from "./MoreActions.vue?vue&type=script&lang=js&"
export * from "./MoreActions.vue?vue&type=script&lang=js&"
import style0 from "./MoreActions.vue?vue&type=style&index=0&id=20919e18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20919e18",
  null
  
)

export default component.exports